module.exports = __webpack_public_path__ + "img/shiba-head-level4.ecd08d47.png";